import UserGroupTree from './src/main';

/* istanbul ignore next */
UserGroupTree.install = function(Vue) {
  Vue.component(UserGroupTree.name, UserGroupTree);
};

export default UserGroupTree;
